export default __webpack_public_path__ + "static/PromptIconEight-29e6be759322021344648b1aa9214c2c.png";